export const getCurrentPosition = options => {
	if (navigator.geolocation) {
		return new Promise((resolve, reject) =>
			navigator.geolocation.getCurrentPosition(resolve, reject, options),
		);
	} else {
		return Promise.reject(new Error('Geolocation services not available'));
	}
};
